import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';

export const getWorkOrderOverview = createAsyncThunk(
    'workOrder/getWorkOrderOverview',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getWorkOrderOverview();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Work Order Overview');
        }
    }
);

export const fetchWorkOrder = createAsyncThunk(
    'workOrder/fetchWorkOrder',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getWorkOrderPaginated(params);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Work Order');
        }
    }
);

export const getVendorsDropdown = createAsyncThunk(
    'workOrder/getVendorsDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getVendorsDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to vendors dropdown');
        }
    }
);

export const getServiceEntryByVehicleDropdown = createAsyncThunk(
    'workOrder/getServiceEntryByVehicleDropdown',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getServiceEntryByVehicleDropdown(params);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch service entry dropdown');
        }
    }
);

export const createWorkOrder = createAsyncThunk(
    'workOrder/createWorkOrder',
    async (workOrderData, { rejectWithValue }) => {
        try {
            const response = await apiService.createWorkOrder(workOrderData);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to create work order');
        }
    }
);

export const workOrderPdfExport = createAsyncThunk(
    'workOrder/workOrderPdfExport',
    async (getIds, { rejectWithValue }) => {
        try {
            const response = await apiService.workOrderPdfExport(getIds);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to export');
        }
    }
);

export const workOrderExcelExport = createAsyncThunk(
    'workOrder/workOrderExcelExport',
    async (getIds, { rejectWithValue }) => {
        try {
            const response = await apiService.workOrderExcelExport(getIds);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to export');
        }
    }
);

export const deleteWorkOrder = createAsyncThunk(
    'workOrder/deleteWorkOrder',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.deleteWorkOrder(id);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to delete Work Order');
        }
    }
);

export const workOrderHistory = createAsyncThunk(
    'workOrder/workOrderHistory',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getWorkOrderHistory(params);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch work order history');
        }
    }
);

export const commentOnWorkOrder = createAsyncThunk(
    'workOrder/commentOnWorkOrder',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.commentOnWorkOrder(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to comment');
        }
    }
);

export const getWorkOrderById = createAsyncThunk(
    'workOrder/getWorkOrderById',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.getWorkOrderById(id);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to get data');
        }
    }
);

export const updateWorkOrder = createAsyncThunk(
    'workOrder/updateWorkOrder',
    async (issueData, { rejectWithValue }) => {
        try {
            const response = await apiService.updateWorkOrder(issueData);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update work order');
        }
    }
);

export const updateRepairPriorityApi = createAsyncThunk(
    'workOrder/updateRepairPriorityApi',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.updateRepairPriority(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update priority');
        }
    }
);

export const updateVendorApi = createAsyncThunk(
    'workOrder/updateVendorApi',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.updateWorkOrderVendor(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update vendor');
        }
    }
);

export const workOrderLinkServiceEntry = createAsyncThunk(
    'workOrder/workOrderLinkServiceEntry',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.workOrderLinkServiceEntry(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update work order link service entry');
        }
    }
);

export const getWorkOrderTagsDropdown = createAsyncThunk(
    'workOrder/getWorkOrderTagsDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.getWorkOrderTagsDropdown();
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update work order tags dropdown');
        }
    }
);

export const emailReminder = createAsyncThunk(
    'workOrder/emailReminder',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.emailReminder(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to emailReminder');
        }
    }
);

export const financialApprovalStatus = createAsyncThunk(
    'workOrder/financialApprovalStatus',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.financialApprovalStatus(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to financialApprovalStatus');
        }
    }
);

export const operationalApprovalStatus = createAsyncThunk(
    'workOrder/operationalApprovalStatus',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.operationalApprovalStatus(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to operationalApprovalStatus');
        }
    }
);

export const updateWorkOrderAssigneeApi = createAsyncThunk(
    'workOrder/updateWorkOrderAssigneeApi',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.updateWorkOrderAssignee(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update assignee');
        }
    }
);

export const updateWorkOrderStatusApi = createAsyncThunk(
    'workOrder/updateWorkOrderStatusApi',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.updateWorkOrderStatus(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update assignee');
        }
    }
);

export const invoiceWorkOrderPdf = createAsyncThunk(
    'workOrder/invoiceWorkOrderPdf',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.invoiceWorkOrderPdf(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to invoiceWorkOrderPdf');
        }
    }
);

const initialState = {
    workOrderOverviewData: null,
    workOrderOverviewLoading: false,
    workOrderOverviewError: null,

    workOrdersData: [],
    workOrdersLoading: false,
    workOrdersError: null,

    getVendorsDropdownData: [],
    getVendorsDropdownLoading: false,
    getVendorsDropdownError: null,

    getServiceEntryByVehicleDropdownData: [],
    getServiceEntryByVehicleDropdownLoading: false,
    getServiceEntryByVehicleDropdownError: null,

    createWorkOrderLoading: false,
    createWorkOrderError: null,

    workOrderPdfExportLoading: false,
    workOrderPdfExportError: null,
    workOrderPdfExportData: {},

    workOrderExcelExportLoading: false,
    workOrderExcelExportError: null,
    workOrderExcelExportData: {},

    deleteWorkOrderLoading: false,
    deleteWorkOrderError: null,

    workOrderHistoryData: [],
    workOrderHistoryLoading: false,
    workOrderHistoryError: null,

    commentOnWorkOrderLoading: false,
    commentOnWorkOrderError: null,

    workOrderByIdData: null,
    workOrderByIdLoading: false,
    workOrderByIdError: null,

    updateWorkOrderLoading: false,
    updateWorkOrderError: null,

    updateRepairPriorityLoading: false,
    updateRepairPriorityError: null,

    updateVendorLoading: false,
    updateVendorError: null,

    workOrderLinkServiceEntryLoading: false,
    workOrderLinkServiceEntryError: null,

    getWorkOrderTagsDropdownData: [],
    getWorkOrderTagsDropdownLoading: false,
    getWorkOrderTagsDropdownError: null,

    emailReminderLoading: false,
    emailReminderError: null,

    financialApprovalStatusLoading: false,
    financialApprovalStatusError: null,

    operationalApprovalStatusLoading: false,
    operationalApprovalStatusError: null,

    updateWorkOrderAssigneeLoading: false,
    updateWorkOrderAssigneeError: null,

    updateWorkOrderStatusLoading: false,
    updateWorkOrderStatusError: null,

    invoiceWorkOrderPdfLoading: false,
    invoiceWorkOrderPdfError: null,
    invoiceWorkOrderPdfData: {},
}

const workOrderSlice = createSlice({
    name: 'workOrder',
    initialState,
    reducers: {
        clearServiceEntryByVehicleDropdown: (state) => {
            state.getServiceEntryByVehicleDropdownData = [];
            state.getServiceEntryByVehicleDropdownLoading = false;
            state.getServiceEntryByVehicleDropdownError = null;
        },
    },
    extraReducers: (builder) => {
        builder

            .addCase(invoiceWorkOrderPdf.pending, (state) => {
                state.invoiceWorkOrderPdfLoading = true;
                state.invoiceWorkOrderPdfError = null;
            })
            .addCase(invoiceWorkOrderPdf.fulfilled, (state, action) => {
                state.invoiceWorkOrderPdfLoading = false;
                state.invoiceWorkOrderPdfData = action.payload?.data || null;
                state.invoiceWorkOrderPdfError = null;
            })
            .addCase(invoiceWorkOrderPdf.rejected, (state, action) => {
                state.invoiceWorkOrderPdfLoading = false;
                state.invoiceWorkOrderPdfError = action.payload || 'Failed to invoiceWorkOrderPdf';
            })

            .addCase(getWorkOrderOverview.pending, (state) => {
                state.workOrderOverviewLoading = true;
                state.workOrderOverviewError = null;
            })
            .addCase(getWorkOrderOverview.fulfilled, (state, action) => {
                state.workOrderOverviewLoading = false;
                state.workOrderOverviewData = action.payload?.data || null;
                state.workOrderOverviewError = null;
            })
            .addCase(getWorkOrderOverview.rejected, (state, action) => {
                state.workOrderOverviewLoading = false;
                state.workOrderOverviewError = action.payload;
                state.workOrderOverviewData = null;
            })

            .addCase(fetchWorkOrder.pending, (state) => {
                state.workOrdersLoading = true;
                state.workOrdersError = null;
            })
            .addCase(fetchWorkOrder.fulfilled, (state, action) => {
                state.workOrdersLoading = false;
                state.workOrdersData = action.payload?.data || null;
                state.workOrdersError = null;
            })
            .addCase(fetchWorkOrder.rejected, (state, action) => {
                state.workOrdersLoading = false;
                state.workOrdersError = action.payload;
                state.workOrdersData = null;
            })

            .addCase(getVendorsDropdown.pending, (state) => {
                state.getVendorsDropdownLoading = true;
                state.getVendorsDropdownError = null;
            })
            .addCase(getVendorsDropdown.fulfilled, (state, action) => {
                state.getVendorsDropdownLoading = false;
                state.getVendorsDropdownData = action.payload?.data || [];
                state.getVendorsDropdownError = null;
            })
            .addCase(getVendorsDropdown.rejected, (state, action) => {
                state.getVendorsDropdownLoading = false;
                state.getVendorsDropdownError = action.payload;
                state.getVendorsDropdownData = [];
            })

            .addCase(getServiceEntryByVehicleDropdown.pending, (state) => {
                state.getServiceEntryByVehicleDropdownLoading = true;
                state.getServiceEntryByVehicleDropdownError = null;
            })
            .addCase(getServiceEntryByVehicleDropdown.fulfilled, (state, action) => {
                state.getServiceEntryByVehicleDropdownLoading = false;
                state.getServiceEntryByVehicleDropdownData = action.payload?.data || [];
                state.getServiceEntryByVehicleDropdownError = null;
            })
            .addCase(getServiceEntryByVehicleDropdown.rejected, (state, action) => {
                state.getServiceEntryByVehicleDropdownLoading = false;
                state.getServiceEntryByVehicleDropdownError = action.payload;
                state.getServiceEntryByVehicleDropdownData = [];
            })

            .addCase(createWorkOrder.pending, (state) => {
                state.createWorkOrderLoading = true;
                state.createWorkOrderError = null;
            })
            .addCase(createWorkOrder.fulfilled, (state, action) => {
                state.createWorkOrderLoading = false;
                state.createWorkOrderError = null;
            })
            .addCase(createWorkOrder.rejected, (state, action) => {
                state.createWorkOrderLoading = false;
                state.createWorkOrderError = action.payload;
            })

            .addCase(workOrderPdfExport.pending, (state) => {
                state.workOrderPdfExportLoading = true;
                state.workOrderPdfExportError = null;
            })
            .addCase(workOrderPdfExport.fulfilled, (state, action) => {
                state.workOrderPdfExportLoading = false;
                state.workOrderPdfExportData = action.payload?.data || {};
                state.workOrderPdfExportError = null;
            })
            .addCase(workOrderPdfExport.rejected, (state, action) => {
                state.workOrderPdfExportLoading = false;
                state.workOrderPdfExportError = action.payload;
                state.workOrderPdfExportData = {};
            })

            .addCase(workOrderExcelExport.pending, (state) => {
                state.workOrderExcelExportLoading = true;
                state.workOrderExcelExportError = null;
            })
            .addCase(workOrderExcelExport.fulfilled, (state, action) => {
                state.workOrderExcelExportLoading = false;
                state.workOrderExcelExportData = action.payload?.data || {};
                state.workOrderExcelExportError = null;
            })
            .addCase(workOrderExcelExport.rejected, (state, action) => {
                state.workOrderExcelExportLoading = false;
                state.workOrderExcelExportError = action.payload;
                state.workOrderExcelExportData = {};
            })

            .addCase(deleteWorkOrder.pending, (state) => {
                state.deleteWorkOrderLoading = true;
                state.deleteWorkOrderError = null;
            })
            .addCase(deleteWorkOrder.fulfilled, (state, action) => {
                state.deleteWorkOrderLoading = false;
                state.deleteWorkOrderError = null;
            })
            .addCase(deleteWorkOrder.rejected, (state, action) => {
                state.deleteWorkOrderLoading = false;
                state.deleteWorkOrderError = action.payload;
            })

            .addCase(workOrderHistory.pending, (state) => {
                state.workOrderHistoryLoading = true;
                state.workOrderHistoryError = null;
            })
            .addCase(workOrderHistory.fulfilled, (state, action) => {
                state.workOrderHistoryLoading = false;
                state.workOrderHistoryData = action.payload?.data || [];
                state.workOrderHistoryError = null;
            })
            .addCase(workOrderHistory.rejected, (state, action) => {
                state.workOrderHistoryLoading = false;
                state.workOrderHistoryError = action.payload;
                state.workOrderHistoryData = [];
            })

            .addCase(commentOnWorkOrder.pending, (state) => {
                state.commentOnWorkOrderLoading = true;
                state.commentOnWorkOrderError = null;
            })
            .addCase(commentOnWorkOrder.fulfilled, (state, action) => {
                state.commentOnWorkOrderLoading = false;
                state.commentOnWorkOrderError = null;
            })
            .addCase(commentOnWorkOrder.rejected, (state, action) => {
                state.commentOnWorkOrderLoading = false;
                state.commentOnWorkOrderError = action.payload;
            })

            .addCase(getWorkOrderById.pending, (state) => {
                state.workOrderByIdLoading = true;
                state.workOrderByIdError = null;
            })
            .addCase(getWorkOrderById.fulfilled, (state, action) => {
                state.workOrderByIdLoading = false;
                state.workOrderByIdData = action.payload?.data || null;
                state.workOrderByIdError = null;
            })
            .addCase(getWorkOrderById.rejected, (state, action) => {
                state.workOrderByIdLoading = false;
                state.workOrderByIdError = action.payload;
                state.workOrderByIdData = null;
            })

            .addCase(updateWorkOrder.pending, (state) => {
                state.updateWorkOrderLoading = true;
                state.updateWorkOrderError = null;
            })
            .addCase(updateWorkOrder.fulfilled, (state, action) => {
                state.updateWorkOrderLoading = false;
                state.updateWorkOrderError = null;
            })
            .addCase(updateWorkOrder.rejected, (state, action) => {
                state.updateWorkOrderLoading = false;
                state.updateWorkOrderError = action.payload;
            })

            .addCase(updateRepairPriorityApi.pending, (state) => {
                state.updateRepairPriorityLoading = true;
                state.updateRepairPriorityError = null;
            })
            .addCase(updateRepairPriorityApi.fulfilled, (state, action) => {
                state.updateRepairPriorityLoading = false;
                state.updateRepairPriorityError = null;
            })
            .addCase(updateRepairPriorityApi.rejected, (state, action) => {
                state.updateRepairPriorityLoading = false;
                state.updateRepairPriorityError = action.payload;
            })

            .addCase(updateVendorApi.pending, (state) => {
                state.updateVendorLoading = true;
                state.updateVendorError = null;
            })
            .addCase(updateVendorApi.fulfilled, (state, action) => {
                state.updateVendorLoading = false;
                state.updateVendorError = null;
            })
            .addCase(updateVendorApi.rejected, (state, action) => {
                state.updateVendorLoading = false;
                state.updateVendorError = action.payload;
            })

            .addCase(workOrderLinkServiceEntry.pending, (state) => {
                state.workOrderLinkServiceEntryLoading = true;
                state.workOrderLinkServiceEntryError = null;
            })
            .addCase(workOrderLinkServiceEntry.fulfilled, (state, action) => {
                state.workOrderLinkServiceEntryLoading = false;
                state.workOrderLinkServiceEntryError = null;
            })
            .addCase(workOrderLinkServiceEntry.rejected, (state, action) => {
                state.workOrderLinkServiceEntryLoading = false;
                state.workOrderLinkServiceEntryError = action.payload;
            })

            .addCase(getWorkOrderTagsDropdown.pending, (state) => {
                state.getWorkOrderTagsDropdownLoading = true;
                state.getWorkOrderTagsDropdownError = null;
            })
            .addCase(getWorkOrderTagsDropdown.fulfilled, (state, action) => {
                state.getWorkOrderTagsDropdownLoading = false;
                state.getWorkOrderTagsDropdownData = action.payload?.data || [];
                state.getWorkOrderTagsDropdownError = null;
            })
            .addCase(getWorkOrderTagsDropdown.rejected, (state, action) => {
                state.getWorkOrderTagsDropdownLoading = false;
                state.getWorkOrderTagsDropdownError = action.payload;
                state.getWorkOrderTagsDropdownData = [];
            })

            .addCase(emailReminder.pending, (state) => {
                state.emailReminderLoading = true;
                state.emailReminderError = null;
            })
            .addCase(emailReminder.fulfilled, (state, action) => {
                state.emailReminderLoading = false;
                state.emailReminderError = null;
            })
            .addCase(emailReminder.rejected, (state, action) => {
                state.emailReminderLoading = false;
                state.emailReminderError = action.payload;
            })

            .addCase(financialApprovalStatus.pending, (state) => {
                state.financialApprovalStatusLoading = true;
                state.financialApprovalStatusError = null;
            })
            .addCase(financialApprovalStatus.fulfilled, (state, action) => {
                state.financialApprovalStatusLoading = false;
                state.financialApprovalStatusError = null;
            })
            .addCase(financialApprovalStatus.rejected, (state, action) => {
                state.financialApprovalStatusLoading = false;
                state.financialApprovalStatusError = action.payload;
            })

            .addCase(operationalApprovalStatus.pending, (state) => {
                state.operationalApprovalStatusLoading = true;
                state.operationalApprovalStatusError = null;
            })
            .addCase(operationalApprovalStatus.fulfilled, (state, action) => {
                state.operationalApprovalStatusLoading = false;
                state.operationalApprovalStatusError = null;
            })
            .addCase(operationalApprovalStatus.rejected, (state, action) => {
                state.operationalApprovalStatusLoading = false;
                state.operationalApprovalStatusError = action.payload;
            })

            .addCase(updateWorkOrderAssigneeApi.pending, (state) => {
                state.updateWorkOrderAssigneeLoading = true;
                state.updateWorkOrderAssigneeError = null;
            })
            .addCase(updateWorkOrderAssigneeApi.fulfilled, (state, action) => {
                state.updateWorkOrderAssigneeLoading = false;
                state.updateWorkOrderAssigneeError = null;
            })
            .addCase(updateWorkOrderAssigneeApi.rejected, (state, action) => {
                state.updateWorkOrderAssigneeLoading = false;
                state.updateWorkOrderAssigneeError = action.payload;
            })

            .addCase(updateWorkOrderStatusApi.pending, (state) => {
                state.updateWorkOrderStatusLoading = true;
                state.updateWorkOrderStatusError = null;
            })
            .addCase(updateWorkOrderStatusApi.fulfilled, (state, action) => {
                state.updateWorkOrderStatusLoading = false;
                state.updateWorkOrderStatusError = null;
            })
            .addCase(updateWorkOrderStatusApi.rejected, (state, action) => {
                state.updateWorkOrderStatusLoading = false;
                state.updateWorkOrderStatusError = action.payload;
            })
    }
});

export const { clearServiceEntryByVehicleDropdown } = workOrderSlice.actions;

export default workOrderSlice.reducer;
